import { useMutation } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface IDeleteFreebieRuleParameters {
    id: string;
}

export const useDeleteFreebieRule = (queryKey: string | string[]) => {
    const auth = useAuth();
    return useMutation({
        mutationFn: async (parameters: IDeleteFreebieRuleParameters) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot archive freebie rule without authorization token.",
                );
            }

            return await api.freebieRule.deleteFreebieRule({
                ...parameters,
                token: auth.token,
            });
        },
    });
};
